import React, { FC } from 'react';
import '../TastesTobacco/style.scss';

interface IPreferencesTitle {
    children: string
}

const PreferencesTitle: FC<IPreferencesTitle> = ({children}) => {
    return (
      <div className="tastes__title">
          {children}
      </div>
    )
};

export default PreferencesTitle;